import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";

interface AllegroAuthStatus {
  authenticated: boolean;
  tokenExpiresAt: string | null;
}

interface AllegroAuthFlow {
  deviceCode: string;
  userCode: string;
  verificationUri: string;
  verificationUriComplete: string;
  expiresIn: number;
  interval: number;
}

interface AllegroAuthResponse {
  success: boolean;
  data: AllegroAuthFlow;
  message: string;
  instructions?: {
    step1: string;
    step2: string;
    step3: string;
    step4: string;
  };
}

interface ExchangeTokenPayload {
  deviceCode: string;
}

export function useAllegroAuthStatus() {
  return useQuery({
    queryKey: ["allegro-auth-status"],
    queryFn: async () => {
      const response = await axiosInstance.get("/allegro/auth/status");
      return response.data.data as AllegroAuthStatus;
    },
    staleTime: 30000, // 30 seconds
    refetchInterval: 60000, // Refetch every minute
    retry: 1,
  });
}

export function useAllegroInitializeAuth() {
  return useMutation({
    mutationFn: async (scopes: string[] = []) => {
      const response = await axiosInstance.post("/allegro/auth/initialize", {
        scopes,
      });
      return response.data as AllegroAuthResponse;
    },
  });
}

export function useAllegroExchangeToken() {
  return useMutation({
    mutationFn: async (payload: ExchangeTokenPayload) => {
      const response = await axiosInstance.post(
        "/allegro/auth/exchange-token",
        payload
      );
      return response.data;
    },
  });
}

export function useAllegroTestConnection() {
  return useMutation({
    mutationFn: async () => {
      const response = await axiosInstance.get("/allegro/config/test");
      return response.data;
    },
  });
}
